
export class PaymentMethod {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    name= '',
                    tax_code= 'loss_reason',
                    external_id= null,
                    interest=null,
                    sync_at= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.name=name;
        this.interest=interest;
        this.tax_code=tax_code;
        this.created_at=created_at;
        this.external_id=external_id;
        this.sync_at=sync_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

    }

}

export function createLabel(data={}) {
    return Object.freeze(new PaymentMethod(data));
}